import React from 'react'
import { CreditCard, ChevronLeft, ChevronRight } from 'lucide-react'

export default function TransactionsTab({ 
  paymentsData, 
  paymentsLoading, 
  paymentStatus, 
  setPaymentStatus, 
  paymentPage, 
  setPaymentPage 
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <select
          value={paymentStatus}
          onChange={(e) => { setPaymentStatus(e.target.value); setPaymentPage(1); }}
          className="px-4 py-2 border rounded-lg"
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
          <option value="cancelled">Cancelled</option>
          <option value="refunded">Refunded</option>
        </select>
      </div>
      
      <div className="bg-zinc-800 rounded-2xl border border-zinc-700 overflow-hidden">
        <table className="w-full">
          <thead className="bg-zinc-900">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">User</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Team</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Amount</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-700">
            {paymentsLoading ? (
              <tr><td colSpan="5" className="px-6 py-12 text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500 mx-auto"></div>
              </td></tr>
            ) : paymentsData?.payments?.length === 0 ? (
              <tr><td colSpan="5" className="px-6 py-12 text-center text-zinc-400">No payments found</td></tr>
            ) : (
              paymentsData?.payments?.map((p) => (
                <tr key={p.invoice_id} className="hover:bg-zinc-900">
                  <td className="px-6 py-4">
                    <div>
                      <p className="font-medium text-white">{p.user_name || 'Unknown'}</p>
                      <p className="text-sm text-zinc-400">{p.user_email}</p>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-zinc-300">{p.team_name || '-'}</td>
                  <td className="px-6 py-4 font-medium">${((p.amount || 0) / 100).toFixed(2)}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      p.status === 'paid' ? 'bg-green-500/20 text-green-400' :
                      p.status === 'pending' ? 'bg-yellow-500/20 text-yellow-400' :
                      p.status === 'refunded' ? 'bg-purple-500/20 text-purple-400' :
                      'bg-zinc-800 text-zinc-200'
                    }`}>
                      {p.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-zinc-400">
                    {p.created_at ? new Date(p.created_at).toLocaleDateString() : '-'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        
        {/* Pagination */}
        <div className="flex items-center justify-between px-6 py-3 border-t">
          <button
            onClick={() => setPaymentPage(p => Math.max(1, p - 1))}
            disabled={paymentPage === 1}
            className="flex items-center gap-1 px-3 py-1 text-sm text-zinc-300 hover:text-white disabled:opacity-50"
          >
            <ChevronLeft className="w-4 h-4" /> Previous
          </button>
          <span className="text-sm text-zinc-400">Page {paymentPage}</span>
          <button
            onClick={() => setPaymentPage(p => p + 1)}
            disabled={!paymentsData?.payments || paymentsData.payments.length < 20}
            className="flex items-center gap-1 px-3 py-1 text-sm text-zinc-300 hover:text-white disabled:opacity-50"
          >
            Next <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
